/** 存放所有的事件，eventName会作为key，然后向他eventName的listener存放在一个数组 */
const EventPool = {};

const addEventListener = (eventName, listener) => {
  if (EventPool[eventName]) {
    EventPool[eventName].push(listener);
  } else {
    EventPool[eventName] = [listener];
  }
}

const dispatchEvent = (eventName, data) => {
  const listeners = EventPool[eventName];
  for (let i = listeners.length - 1; i >= 0; i--) {
    listeners[i](data);
  }
}

/** JS跳转 */
const routetrGo = (path) => {
  const pageUrl = window.location.href;
  if (pageUrl.indexOf('drpanda') > -1 && (pageUrl.substr(- 4, pageUrl.length - 1) === 'com/' || pageUrl.indexOf('index.html') > -1)) {
    window.location.href = `https://drpanda.com/${path}/index.html`;
  } else {
    window.location.href = `/${path}`
  }
}

const domainJudge = () =>{
  let domainServer = ''
  const pageUrl = window.location.href;
  if(pageUrl.indexOf('.xiongmaonboshi') > -1) {
    domainServer = 'ali'
  } else if(pageUrl.indexOf('.drpanda') > -1) {
    domainServer = 'aws'
  }
  return domainServer;
}

/** a标签跳转 */
const hrefLink = (path) => {
  console.log('hrefLink', path);
  let aLink = '';
  if (path.indexOf('http') > -1) {
    return path;
  }
  const pageUrl = window.location.href;
  if (pageUrl.indexOf('drpanda') > -1 && path) {
    aLink = `/${path}/index.html`;
  } else {
    aLink = `/${path}`
  }
  return aLink;
}

export default {
  addEventListener,
  dispatchEvent,
  routetrGo,
  hrefLink,
  domainJudge,
}
